// Author thq
// Date 2022-03-02 15:01:59

import * as model from "@/model/em/archive/EmLocationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmLocation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        selectRowsToItems: function (row) {
            return {value: row.code, text: row.name}
        },
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emLocation',
        modelFilter: model.filter
    })
    .buildStore()
